import React, {FC, PropsWithChildren, useEffect, useState} from 'react';
import {DNDContext, LocationType} from './DNDContext';
import {Record} from '../../../../../stores/Form';
import {MovingLocation} from '../../../types';

interface DNDControllerProps {
    onDragEndHandler: (
        from: LocationType,
        to: LocationType,
        movingRecords: Record[],
        originalMovingRecords?: any[]
    ) => void;
    getGroupRecords: (id: number, records: Record[], groupInd?: string) => Promise<Record[]>;
    getRouteIdByTableId: (tableId: string) => number;
}

export const DNDController: FC<PropsWithChildren<DNDControllerProps>> = ({
    onDragEndHandler,
    children,
    getGroupRecords,
    getRouteIdByTableId
}) => {
    const [isMoving, setIsMoving] = useState<boolean>(false);
    const [coordinates, setCoordinates] = useState<[number, number] | undefined>(undefined);
    const [from, setFrom] = useState<LocationType>(undefined);
    const [to, setTo] = useState<LocationType>(undefined);
    const [movingRecords, setMovingRecords] = useState<Record[]>([]);

    useEffect(() => {
        if (!isMoving && coordinates) {
            setCoordinates(undefined);
        }
    }, [isMoving, coordinates]);

    useEffect(() => {
        const resetState = () => {
            setFrom(undefined);
            setTo(undefined);
            setMovingRecords([]);
        };

        const handleMove = async () => {
            if (from && to) {
                console.log(from, '->', to, movingRecords);

                const mapDND = async () => {
                    if (Number.isInteger(from.row) && Number.parseInt(from.group) >= 0) {
                        const routeId = (movingRecords.find(x => (x as any).route) as any).route.id;
                        const toRouteId = to.id.startsWith('table') && getRouteIdByTableId(to.id);
                        if (Number.parseInt(routeId) !== toRouteId) {
                            const filteredMovingRecords = movingRecords.filter(
                                r => (r as any).route
                            );
                            const records = await getGroupRecords(
                                routeId,
                                filteredMovingRecords.map(r => (r as any).record),
                                from.row.toString()
                            );
                            await onDragEndHandler(from, to, records, filteredMovingRecords);
                        }
                    } else {
                        await onDragEndHandler(
                            from,
                            to,
                            movingRecords.filter(r => !(r as any).route).map(r => (r as any).record)
                        );
                    }
                };

                if (from.id !== to.id) {
                    if (from.id.startsWith(MovingLocation.map)) {
                        await mapDND();
                    } else {
                        if (from.group === undefined) {
                            await onDragEndHandler(
                                from,
                                to,
                                movingRecords.filter(record => record.recordIndex >= 0)
                            );
                        } else {
                            const routeId = getRouteIdByTableId(from.id);
                            if (
                                !to.id.startsWith(MovingLocation.map) ||
                                Number.parseInt(to.group) !== routeId
                            ) {
                                const records = await getGroupRecords(
                                    routeId,
                                    movingRecords.filter(record => record.recordIndex < 0),
                                    from.group
                                );
                                await onDragEndHandler(from, to, records);
                            }
                        }
                    }
                } else if (from.id.startsWith(MovingLocation.table2)) {
                    await onDragEndHandler(from, to, movingRecords);
                } else if (from.id.startsWith(MovingLocation.map)) {
                    await mapDND();
                }
                resetState();
            } else if (!isMoving) {
                resetState();
            }
        };

        handleMove();
    }, [from, to]);

    return (
        <DNDContext.Provider
            value={{
                isMoving,
                setIsMoving,
                coordinates,
                setCoordinates,
                from,
                setFrom,
                setTo,
                setMovingRecords,
                movingRecords
            }}
        >
            <>{children}</>
        </DNDContext.Provider>
    );
};
